import { render, staticRenderFns } from "./contactsEdit.vue?vue&type=template&id=4d761968&"
import script from "./contactsEdit.vue?vue&type=script&lang=js&"
export * from "./contactsEdit.vue?vue&type=script&lang=js&"
import style0 from "./contactsEdit.vue?vue&type=style&index=0&id=4d761968&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports